import React from 'react'
import Link from '../../../components/link/Link'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'
import { ServiceContentModel } from '../../../types/services/serviceModel'
import { saveInteractions } from '../../gtm/utils/gtmCallback'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            serviceContainerStyle: {
                marginBottom: 30,
                position: 'relative'
            },
            imageContainerStyle: {
                '& img': {
                    position: 'relative',
                    zIndex: 1
                }
            },
            serviceStyle: {
                background: 'white',
                position: 'relative'
            },
            serviceLargeScreenStyle: {
                marginTop: '-204px',
                height: 200,
                padding: '225px 45px 45px',
            },
            serviceSmallScreenStyle: {
                marginTop: '-120px',
                padding: '140px 45px 45px',
            },
            titleContainerStyle: {
                display: 'flex',
                alignItems: 'center',

                '& h1': {
                    margin: '0px !important',
                    marginLeft: '17px !important'
                }
            },
            hookStyle: {
                color: theme.palette.blue.main,
                wordBreak: 'break-word',
                '& p': {
                    marginTop: '15px !important',
                    marginBottom: '15px !important'
                }
            },
            linkContainerStyle: {
                position: 'absolute',
                bottom: 20
            }
        }
    )
)

interface AcceptingProps {
    service: ServiceContentModel
}

type ServiceItemProps = AcceptingProps

const ServiceItem: React.FC<ServiceItemProps> = (
    {
        service
    }
) => {
    const classes = useStyle()
    const history = useHistory()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )
    const MAX_LENGTH = isLargeScreen ? 250 : 1000

    const serviceClass: ClassValue = classNames(
        classes.serviceStyle,
        isLargeScreen ? classes.serviceLargeScreenStyle : classes.serviceSmallScreenStyle
    )

    const titleClass: ClassValue = classNames(
        classes.colorAccessibility,
        isLargeScreen ? classes.title6 : classes.title3
    )

    const hookClass: ClassValue = classNames(
        classes.text2,
        classes.hookStyle
    )

    const seeDetails = (id: string) => {
        saveInteractions(
            {
                category: 'Services',
                action: 'Blocs de mise en avant',
                label: service.title
            }
        )

        history.push(`${links.services}/${id}`)
    }

    const cutStringKeepingWord = (text: string) => {
        if (text.length <= MAX_LENGTH) {
            return text
        }
        const trimmedString = text.substr(0, MAX_LENGTH)
        return `${trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))}...`
    }

    return (
        <>
            <div
                className={classes.serviceContainerStyle}
                key={service.id}
            >
                <div className={classes.imageContainerStyle}>
                    <img
                        src={service.picture}
                        alt={service.alternative_text || 'Service pic'}
                        width={isLargeScreen ? 350 : 200}
                        height={isLargeScreen ? 285 : 150}
                    />
                </div>
                <div className={serviceClass}>
                    <div className={classes.titleContainerStyle}>
                        <img
                            src={service.picto}
                            alt={service.picto_alternative_text || 'Picto service'}
                            width={50}
                            height={50}
                        />

                        <h1 className={titleClass}>{service.title}</h1>
                    </div>

                    <div className={hookClass}>
                        <p>{cutStringKeepingWord(service.hook)}</p>
                    </div>

                    <div className={classes.linkContainerStyle}>
                        <Link
                            onClick={() => seeDetails(service.id)}
                            color="colorAccessibility"
                            textStyle="text8"
                        >
                            <FormattedMessage
                                id="app.details"
                                defaultMessage="En savoir plus"
                                description="Learn more link"
                            />
                        </Link>
                    </div>

                </div>
            </div>

        </>
    )
}

export default (ServiceItem)
